import { render, staticRenderFns } from "./step-questionnaire.vue?vue&type=template&id=4ea2fa00&scoped=true&"
import script from "./step-questionnaire.vue?vue&type=script&lang=js&"
export * from "./step-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./step-questionnaire.vue?vue&type=style&index=0&id=4ea2fa00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea2fa00",
  null
  
)

export default component.exports